<template>
  <main class="organization-contragent">
    <loading-container :loading="loading" height="99">
      <div class="contragent-container row">
        <div class="col-5">
          <div class="contragent-item">
            <div class="content">
              <img :src="profile.logo" v-if="profile.logo" class="icon">
              <p class="title">{{profile.name}}</p>
              <div class="foundation_date">{{profile.foundation_date}}</div>
              <div class="about-block">
                <p v-html="profile.about"></p>
              </div>
              <p class="phone">{{profile.phone}}</p>
              <p>{{profile.email}}</p>
              <p class="link">{{profile.site}}</p>
              <p v-for="address in profile.office_addresses" :key="'address' + address.id">{{address.human_address}}</p>
            </div>
            <div class="rate">
              <app-rate-star :config="config" />
            </div>
          </div>
          <div class="bordered-card" v-if="contract.type == 1">
            <div class="bordered-card__head">Бренды</div>
            <div class="bordered-card__items">
              <table v-if="brands.length > 0">
                <tr>
                  <!--<th>Фото</th>-->
                  <th>Название</th>
                  <th>Статус</th>
                </tr>
                <tr v-for="item in brands" :key="item.id">
                  <!--<td class="tc">
                    <img class="brand-img" :src="item.image" alt="">
                  </td>-->
                  <td class="tc">
                    {{item.name}}
                  </td>
                  <td class="tc">
                    {{item.status}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="bordered-card" v-if="contract.type == 1">
            <div class="bordered-card__head">
              Товарные категории поставщика
              <div class="drop-header drop-status" v-if="$store.getters.getCompany.dropshipping && cont && can('page.dropshipping.permission') && type == 2">
                Дропшиппинг
              </div>
              <div class="drop-header" v-if="$store.getters.getCompany.dropshipping && cont && can('page.dropshipping.permission') && type == 2">
                Подключить дропшиппинг
              </div>
            </div>
            <div class="bordered-card__items">
              <div class="tree-container">
                <tree :data="categories" :key="key" :options="{dropshipping: $store.getters.getCompany.dropshipping && cont && can('page.dropshipping.permission') && type == 2, checkbox: $store.getters.getCompany.dropshipping && cont && can('page.dropshipping.permission') && type == 2, deletion: false}" @node:checked="select" @node:unchecked="select"/>
                <button class="btn-join" @click="send()" v-if="$store.getters.getCompany.dropshipping && cont && can('page.dropshipping.permission') && type == 2">Сохранить</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div v-if="entities.length > 0" style="font-weight: bold; font-size: 17px;">Действующие юр. лица</div>
          <table v-if="entities.length > 0">
            <tr>
              <td>Наименование</td>
              <td>ИНН</td>
              <td>КПП</td>
              <td>ОГРН</td>
            </tr>
            <tr v-for="entity in entities" :key="entity.id">
              <td>{{entity.company_name}}</td>
              <td>{{entity.inn}}</td>
              <td>{{ entity.kpp}}</td>
              <td>{{entity.ogrn}}</td>
            </tr>
          </table>
          <br>
          <div v-if="ip.length > 0" style="font-weight: bold; font-size: 17px;">Действующие ИП</div>
          <table v-if="ip.length > 0">
            <tr>
              <td>Наименование</td>
              <td>ИНН</td>
              <td>ОГРНИП</td>
            </tr>
            <tr v-for="entity in ip" :key="entity.id">
              <td>{{entity.company_name}}</td>
              <td>{{entity.inn}}</td>
              <td>{{entity.ogrn}}</td>
            </tr>
          </table>
<!--          <div v-if="entities.length > 0">
            <div style="margin-bottom: 40px;" v-for="entity in entities" :key="entity.id">
              <div style="margin-bottom: 20px;">
                <table>
                  <tr>
                    <td>Юридическое название компании</td>
                    <td>{{entity.company_name}}</td>
                  </tr>
                  <tr>
                    <td>ИНН</td>
                    <td>{{entity.inn}}</td>
                  </tr>
                  <tr v-if="entity.type == 1">
                    <td>КПП</td>
                    <td>{{entity.kpp}}</td>
                  </tr>
                  <tr>
                    <td>{{entity.type == 1 ? 'ОГРН' : 'ОГРНИП'}}</td>
                    <td>{{entity.ogrn}}</td>
                  </tr>
                  <tr>
                    <td>Телефон</td>
                    <td>{{entity.phone}}</td>
                  </tr>
                  <tr>
                    <td>E-mail</td>
                    <td>{{entity.email}}</td>
                  </tr>
                  <tr>
                    <td>Тип</td>
                    <td>{{entity.type == 1 ? 'Юр. лицо' : 'ИП'}}</td>
                  </tr>
                </table>
              </div>
              <div style="margin-bottom: 20px;">
                <table>
                  <tr>
                    <td>Должность</td>
                    <td>{{entity.position}}</td>
                  </tr>
                  <tr>
                    <td>Фамилия</td>
                    <td>{{entity.surname}}</td>
                  </tr>
                  <tr>
                    <td>Имя</td>
                    <td>{{entity.name}}</td>
                  </tr>
                  <tr>
                    <td>Отчество</td>
                    <td>{{entity.patronymic}}</td>
                  </tr>
                  <tr>
                    <td>Действует на основании</td>
                    <td>{{entity.act}}</td>
                  </tr>
                  <tr>
                    <td>Дата выдачи</td>
                    <td>{{entity.date_issue}}</td>
                  </tr>
                  <tr>
                    <td>Срок действия</td>
                    <td>{{entity.date_from}} - {{entity.date_to}}</td>
                  </tr>
                </table>
              </div>
              <div style="margin-bottom: 20px;" v-for="requisite in entity.requisites" :key="'requisite-' + requisite.id">
                <table>
                  <tr>
                    <td>Название счета</td>
                    <td>{{requisite.name}}</td>
                  </tr>
                  <tr>
                    <td>Расчетный счет</td>
                    <td>{{requisite.checking_account}}</td>
                  </tr>
                  <tr>
                    <td>Корреспондентский счет</td>
                    <td>{{requisite.correspondent_account}}</td>
                  </tr>
                  <tr>
                    <td>БИК</td>
                    <td>{{requisite.bik}}</td>
                  </tr>
                  <tr>
                    <td>Название банка</td>
                    <td>{{requisite.bank}}</td>
                  </tr>
                  <tr>
                    <td>Адрес банка</td>
                    <td>{{requisite.bank_address}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>-->
          <br>
          <div class="contragent-review" v-for="(item, idx) in reviews" :key="idx">
            <div class="top">
              <img :src="item.avatar" alt="" class="avatar">
              <div class="info">
                <div class="name">{{item.name}}</div>
                <div class="date">{{item.date}}</div>
              </div>
              <div class="rate">
                <app-rate-star :config="item.config" />
              </div>
            </div>
            <div class="text">{{item.text}}</div>
          </div>
          <div class="more" v-if="last_page > page" @click="changePage()">Показать еще</div>
        </div>

<!--        <div class="contragent-actions col-3">-->
<!--          <button class="confirm" v-if="canChange && !contract.accept" @click="acceptContract()">Подтвердить запрос</button>-->
<!--          <button class="edit">Сформировать закупку</button>-->
<!--          <button class="delete" @click="sendMessage()">Написать</button>-->
<!--          <button class="delete">Удалить</button>-->
<!--        </div>-->
      </div>
    </loading-container>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppRateStar from "@/components/app-rate-star";

export default {
  name: "contragent",
  components: {LoadingContainer, AppRateStar},
  data: function () {
    return {
      canChange: false,
      profile: [],
      page: 1,
      last_page: 10,
      loading: true,
      contract: [],
      cont: false,
      selected: [],
      brands: [],
      key: 1,
      type: '',
      selected_categories: [],
      disabled_categories: [],
      config: {
        rating: 0,
        amount: 0,
        isIndicatorActive: true,
        isIndicatorAmountActive: true,
      },
      reviews:[],
      categories: [],
      entities: [],
      ip: []
    }
  },
  mounted() {
    this.type = localStorage.getItem('type');

    if (this.$route.query.drop) {
      if (this.type == 1) {
        this.$route.meta.back1 = 'drpurchasers';
      }
    }
    this.getContract();
  },
  methods: {
    getContract() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-profile', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id,
        }).then(({data}) => {
          if (data.company) {
            this.contract = data.company;
            if (data.company.type == 1) {
              this.getCategories();
              this.getBrands();
            }
            if (data.company.initiator != localStorage.getItem('type')) {
              this.canChange = true;
            }
            this.profile = data.company
            // if (localStorage.getItem('type') == 2) {
            //   this.profile = data.contract.provider;
            // } else {
            //   this.profile = data.company.purchaser;
            // }
            this.getReviews();
          }

          if (data.contract) {
            this.cont = true;
          }

          /*this.entities = data.entities;*/
          for (let i in data.entities) {
            if (data.entities[i].type == 1) {
              this.entities.push(data.entities[i]);
            } else {
              this.ip.push(data.entities[i]);
            }
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    autoDisabled(data){
      let disabled = this.disabled_categories
      let th = this

      return data.map((item)=>{
        if(item.children){
          item.children = th.autoDisabled(item.children)
        }
        item.state = {}
        if(disabled.some(sel => {
          return String(sel) == String(item.id)
         })){
           item.state.disabled = true
        }else{
          item.state.disabled = false
        }
        if (item.dropshipping == null) {
          item.state.without_checkbox = true
        } else {
          item.state.without_checkbox = false
        }
        return item;
      })
    },
    autoSelect(data){
      let selected = this.selected_categories
      let th = this

      return data.map((item)=>{
        if(item.children){
          item.children = th.autoSelect(item.children)
        }
        if (!item.state) {
          item.state = {}
        }
        if(selected.some(sel => {
          return String(sel) == String(item.id)
        })){
          item.state.checked = true
        }else{
          item.state.checked = false
        }
        return item;
      })
    },
    select(val) {
      this.selected = [];
      val.tree.checkedNodes.forEach((item)=>{
        if (!this.disabled_categories.includes(item.id)) {
          this.selected.push(item.id)
        }
      })
    },
    send() {
      this.$http.post( '/add-purchaser-dropshipping-categories',{
        token: localStorage.getItem('token'),
        categories: this.selected,
        id: this.contract.user_id
      }).then(({data}) => {
        if (data.success) {
          this.getCategories();
          this.$toast.success('Категории успешно изменены');
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    changePage() {
      this.page++;
      this.getReviews();
    },
    getReviews() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-order-reviews', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id,
          page: this.page
        }).then(({data}) => {
          if (data.reviews) {
            for (let key in data.reviews.data) {
              this.reviews.push({
                avatar: data.reviews.data[key].review_author.company.logo,
                name: data.reviews.data[key].review_author.company.name,
                date: data.reviews.data[key].time,
                config: {
                  rating: data.reviews.data[key].rate,
                  isIndicatorActive: true,
                  isIndicatorAmountActive: false,
                },
                text: data.reviews.data[key].review
              });
            }

            this.last_page = data.reviews.last_page;
            this.config.amount = data.reviews.total;
            this.config.rating = data.avg;
          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> this.loading = false)
      }
    },
    getCategories() {
      this.$http.post( '/get-categories',{
        token: localStorage.getItem('token'),
        id: this.$route.params.id,
      }).then(({data}) => {
        if (this.$store.getters.getCompany.dropshipping && this.cont && this.can('page.dropshipping.permission') && this.type == 2) {
          if (data.disabled_categories) {
            this.disabled_categories = data.disabled_categories;
            this.autoDisabled(data.categories);
          }

          if (data.checked_categories) {
            this.selected_categories = data.checked_categories;
            this.autoSelect(data.categories);
          }
        }

        if (data.categories) {
          this.categories = data.categories;
          this.key++;
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    getBrands() {
      this.$http.post( '/get-provider-brands',{
        token: localStorage.getItem('token'),
        id: this.contract.user_id,
      }).then(({data}) => {
        if (data.brands) {
          this.brands = data.brands;
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
    },
    acceptContract() {
      if (localStorage.getItem('token')) {
        this.$http.post('/accept-contract', {
          token: localStorage.getItem('token'),
          id: this.contract.id,
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Запрос успешно подтвержден!');
          }
        })
            .catch((error) => {
              console.log(error)
            })
            .finally(()=> this.loading = false)
      }
    },
    sendMessage() {
      if (localStorage.getItem('token')) {
        this.$http.post('/create-chat', {
          token: localStorage.getItem('token'),
          id: this.profile.id,
        }).then(({data}) => {
          if (data.success) {
            this.$router.push('/chat?company=' + this.profile.id);
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
  }
}
</script>

<style>
.tree-content {
  padding-right: 48px;
}


@media (max-width: 1700px) {
  .col-5 {
    flex: 0 0 60.666667%;
    max-width: 60.666667%;
  }
}
</style>
<style scoped lang="scss">
.about-block {
  padding: 0px 16px;
}
.drop-status {
  right: 194px !important;
  top: 13px !important;
}
.foundation_date {
  margin-bottom: 10px;
  font-weight: normal;
  color: #B6BCC8;
  font-size: 14px;
}

.drop-header {
  position: absolute;
  width: 100px;
  right: 6px;
  top: 6px;
}

.brand-img {
  max-width: 40px;
  max-height: 40px;
}
.tc {
  vertical-align: middle;
}
.btn-join {
    padding: 0 16px;
    background: #2CB181;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    width: 160px;
    margin: 10px 0px 5px 8px;
}
.bordered-card{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    margin-top: 20px;
    width: 100%;

  &__head{
     padding: 15px;
     border-bottom: 1px solid #EEF0F3;
     position: relative;
   }
  &__items{
     background: #FFFFFF;
   }
}
main {
  flex: 1;
  padding: 0 30px;
  margin-top: 30px;
}
.more{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #636974;
}
.organization-contragent {
  width: 100%;

  .contragent-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .contragent-item {
    height: max-content;
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    .rate{
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .content {
      color: #7A818F;
      font-size: 14px;
      line-height: 16px;
      font-weight: normal;
      padding: 17px 15px;
      .icon {
        margin-top: 15px;
        max-height: 100px;
        height: 100px;
        margin-bottom: 20px;
      }
      .title{
        height: 20px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #2D3137;
      }
      p {
        margin-bottom: 9px;

        &.black {
          color: #2D3137;
        }

        &.phone {
          margin-top: 25px;
          color: #2CB181;
          font-weight: 500;
        }
        &.link{
          margin-bottom: 9px;
          color: #7A818F;
          text-decoration: underline;
        }
      }

      a {
        color: #7A818F;
        text-decoration: underline;
      }
    }
  }

  .contragent-review {
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    margin-bottom: 5px;
    padding: 20px;
    .top{
      display: flex;
      align-items: center;
      .avatar{
        height: 30px;
        width: 30px;
        margin-right: 10px;
      }
      .info{
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        .name{
          color: #2cb181;
        }
        .date{
          font-weight: normal;
          color: #B6BCC8;
        }
      }
      .rate{
        margin-left: auto;
        margin-top: auto;
      }
    }
    .text{
      margin-top: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #636974;
    }
  }


  .contragent-actions {
    text-align: center;
    padding: 0 15px 0 0;
    button {
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      width: 100%;
      height: 50px;
      outline: none;
      margin-bottom: 10px;

      &:first-child {
        margin-right: 15px;
      }

      &.delete {
        border: 1px solid #B6BCC8;
        color: #7A818F;
        background: none;
      }

      &.edit {
        background: #2CB181;
        border: none;
        color: #FFFFFF;
      }
      &.confirm {
        background: #F39220;
        border: none;
        color: #FFFFFF;
      }
    }
  }
}
</style>